import clearForm from "@iewc/Store/Handlers/CreateAccount/ClearForm";
import setFieldValue from "@iewc/Store/Handlers/CreateAccount/SetFieldValue";
import submitCreateAccountForm from "@iewc/Store/Handlers/CreateAccount/SubmitCreateAccountForm";
import secondClearForm from "@iewc/Store/Handlers/InstantRegistrationForm/ClearForm";
import { CustomState } from "@iewc/Store/Reducers";
import BillingAddressLineOne from "@iewc/Widgets/CreateAccount/BillingAddress/AddressLineOne";
import BillingAddressLineTwo from "@iewc/Widgets/CreateAccount/BillingAddress/AddressLineTwo";
import BillingCity from "@iewc/Widgets/CreateAccount/BillingAddress/CIty";
import BillingCompany from "@iewc/Widgets/CreateAccount/BillingAddress/Company";
import BillingCountry from "@iewc/Widgets/CreateAccount/BillingAddress/Country";
import BillingEmail from "@iewc/Widgets/CreateAccount/BillingAddress/Email";
import BillingFirstName from "@iewc/Widgets/CreateAccount/BillingAddress/FirstName";
import BillingLastName from "@iewc/Widgets/CreateAccount/BillingAddress/LastName";
import BillingPhone from "@iewc/Widgets/CreateAccount/BillingAddress/Phone";
import BillingState from "@iewc/Widgets/CreateAccount/BillingAddress/State";
import UseShippingAddress from "@iewc/Widgets/CreateAccount/BillingAddress/UseShippingAddress";
import BillingZipCode from "@iewc/Widgets/CreateAccount/BillingAddress/ZipCode";
import ShippingAddressLineOne from "@iewc/Widgets/CreateAccount/ShippingAddress/AddressLineOne";
import ShippingAddressLineTwo from "@iewc/Widgets/CreateAccount/ShippingAddress/AddressLineTwo";
import ShippingCity from "@iewc/Widgets/CreateAccount/ShippingAddress/CIty";
import ShippingCompany from "@iewc/Widgets/CreateAccount/ShippingAddress/Company";
import ShippingCountry from "@iewc/Widgets/CreateAccount/ShippingAddress/Country";
import ShippingEmail from "@iewc/Widgets/CreateAccount/ShippingAddress/Email";
import ShippingFirstName from "@iewc/Widgets/CreateAccount/ShippingAddress/FirstName";
import ShippingLastName from "@iewc/Widgets/CreateAccount/ShippingAddress/LastName";
import ShippingPhone from "@iewc/Widgets/CreateAccount/ShippingAddress/Phone";
import ShippingState from "@iewc/Widgets/CreateAccount/ShippingAddress/State";
import ShippingZipCode from "@iewc/Widgets/CreateAccount/ShippingAddress/ZipCode";
import TaxExemption from "@iewc/Widgets/CreateAccount/TaxExemption";
import BusinessType from "@iewc/Widgets/CreateAccount/UserInformation/BusinessType";
import UserCompany from "@iewc/Widgets/CreateAccount/UserInformation/Company";
import ConfirmUserEmail from "@iewc/Widgets/CreateAccount/UserInformation/ConfirmEmail";
import UserEmail from "@iewc/Widgets/CreateAccount/UserInformation/Email";
import UserFirstName from "@iewc/Widgets/CreateAccount/UserInformation/FirstName";
import Industry from "@iewc/Widgets/CreateAccount/UserInformation/Industry";
import UserJobTItle from "@iewc/Widgets/CreateAccount/UserInformation/JobTItle";
import UserLastName from "@iewc/Widgets/CreateAccount/UserInformation/LastName";
import PreviouslyPurchased from "@iewc/Widgets/CreateAccount/UserInformation/PreviouslyPurchased";
import WebsiteUrl from "@iewc/Widgets/CreateAccount/UserInformation/WebsiteUrl";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { get } from "@insite/client-framework/Services/ApiService";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    emailRecipients = "emailRecipients",
    submitButtonText = "submitButtonText",
    taxExemptHeading = "taxExemptHeading",
    taxExemptCheckboxLabel = "taxExemptCheckboxLabel",
    uploadTaxformContent = "uploadTaxformContent",
    successLink = "successLink",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.emailRecipients]: string;
        [fields.submitButtonText]: string;
        [fields.taxExemptHeading]: string;
        [fields.taxExemptCheckboxLabel]: string;
        [fields.uploadTaxformContent]: string;
        [fields.successLink]: LinkFieldValue;
    };
}

const mapStateToProps = (state: CustomState) => ({
    previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
    useShippingAddress: state.customCreateAccountForm.fieldValues.useShippingAddress,
    taxExempt: state.customCreateAccountForm.fieldValues.taxExempt,
});

const mapDispatchToProps = {
    submitCreateAccountForm,
    clearForm,
    secondClearForm,
    setFieldValue,
    validateReCaptcha: makeHandlerChainAwaitable<{ location: string; recaptchaRef: React.RefObject<ReCAPTCHA> }, boolean>(
        validateReCaptcha,
    ),
};

const shippingKeys = [
    "shippingFirstName",
    "shippingLastName",
    "shippingEmail",
    "shippingCompany",
    "shippingAddressLineOne",
    "shippingAddressLineTwo",
    "shippingCountry",
    "shippingState",
    "shippingCity",
    "shippingZipCode",
    "shippingPhone",
]

const billingKeys = [
    "billingFirstName",
    "billingLastName",
    "billingEmail",
    "billingCompany",
    "billingAddressLineOne",
    "billingAddressLineTwo",
    "billingCountry",
    "billingState",
    "billingCity",
    "billingZipCode",
    "billingPhone",
]

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;


export interface CreateAccountFormStyles {
    container?: GridContainerProps;
    formGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    messageTextGridItem?: GridItemProps;
    messageText?: TypographyPresentationProps;
    buttonGridItem?: GridItemProps;
    captchaWrapper?: InjectableCss;
    captchaLabel?: TypographyPresentationProps;
    continueButton?: ButtonPresentationProps;
}

export const createAccountFormStyles: CreateAccountFormStyles = {
    container: {
        gap: 0,
        css: css`
            padding-top: 30px;
            padding-bottom: 30px;

            /* stylelint-disable-next-line */
            #requestQuoteForm {
                width: 100%;
            }
        `,
    },
    formGridItem: { width: 12 },
    submitButton: {
        css: css`
            margin-top: 20px;
        `,
    },
    messageTextGridItem: { width: 12 },
    captchaWrapper: {
        css: css`
            margin-top: 20px;
        `,
    },
    captchaLabel: {
        variant: "body",
        forwardAs: "label",
        weight: "bold",
        css: css`
            display: block;
            margin-bottom: 6px;
        `,
    },
    buttonGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
};

const styles = createAccountFormStyles;
const emailsRegexp = new RegExp(
    "^[\\W]*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4}[\\W]*,{1}[\\W]*)*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4})[\\W]*$",
);

type Validator = () => boolean;
type ContextType = {
    validators: {
        [key: string]: Validator | undefined;
    };
    countries: any[];
};

export const CreateAccountFormContext = React.createContext<ContextType>({
    validators: {},
    countries: [],
});

const CreateAccountForm = ({
    id,
    fields: widgetFields,
    submitCreateAccountForm: widgetSubmitRequestQuoteForm,
    clearForm,
    secondClearForm,
    validateReCaptcha: widgetValidateReCaptcha,
    previouslyPurchased,
    useShippingAddress,
    taxExempt,
    setFieldValue
}: Props) => {
    const { emailRecipients, submitButtonText } = widgetFields;
    const [validators] = useState<{ [key: string]: Validator | undefined }>({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isPreviouslyPurchased = previouslyPurchased === 'true';
    const isUsingShippingAddress = useShippingAddress === 'true';
    const recaptchaRef: React.RefObject<ReCAPTCHA> = React.createRef();
    const [countries, setCountries] = useState([]);
    const history = useHistory();
    const link = useGetLink(widgetFields.successLink);
    const TaxExemptionField = TaxExemption as any;
    const { current: Fields } = useRef({
        UserEmail,
        ConfirmUserEmail,
        UserFirstName,
        UserLastName,
        UserJobTItle,
        UserCompany,
        WebsiteUrl,
        Industry,
        BusinessType,
        PreviouslyPurchased,
        ShippingEmail,
        ShippingAddressLineOne,
        ShippingAddressLineTwo,
        ShippingCity,
        ShippingState,
        ShippingZipCode,
        ShippingCountry,
        ShippingPhone,
        ShippingFirstName,
        ShippingLastName,
        ShippingCompany,
        BillingEmail,
        BillingAddressLineOne,
        BillingAddressLineTwo,
        BillingCity,
        BillingState,
        BillingZipCode,
        BillingCountry,
        BillingPhone,
        BillingFirstName,
        BillingLastName,
        BillingCompany,
        UseShippingAddress
    } as any)

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const widgetValidators: Validator[] = [];
        let widgetValidatorKeys = Object.keys(validators);
        if (previouslyPurchased === 'true') {
            widgetValidatorKeys = widgetValidatorKeys.filter(key => !shippingKeys.includes(key));
            widgetValidatorKeys = widgetValidatorKeys.filter(key => {
                if (["billingCountry", "billingState", "billingCity"].includes(key)) {
                    return true;
                }
                return !billingKeys.includes(key)
            });
        }
        if (isUsingShippingAddress) {
            widgetValidatorKeys = widgetValidatorKeys.filter(key => !billingKeys.includes(key));
        }

        if (taxExempt !== 'true') {
            widgetValidatorKeys = widgetValidatorKeys.filter(key => key !== 'file');
        }

        widgetValidatorKeys.forEach(key => {
            const validator = validators[key];
            if (validator) {
                widgetValidators.push(validator);
            }
        });
        const results = widgetValidators.map(v => v());
        if (!results.every(o => o)) {
            return;
        }

        const isReCaptchaValid = await widgetValidateReCaptcha({ location: "ContactUs", recaptchaRef });

        if (!isReCaptchaValid) {
            return;
        }

        setIsSubmitting(true);
        widgetSubmitRequestQuoteForm({
            emailRecipients,
            onSuccess: () => {
                setIsSubmitting(false);
                clearForm();
                secondClearForm();
                if (link.url) {
                    history.push(link.url);
                }
            },
            onComplete() {
                this.onSuccess?.();
            },
         });
    };

    const fetchCountries = async () => {
        const res = await get("api/v1/CustomCountries/countries") as any;
        setCountries(res?.length ? res : []);
    }

    React.useEffect(() => {
        fetchCountries();
    }, []);

    useEffect(() => {
        if (useShippingAddress === 'true') {
            billingKeys.forEach(key => {
                setFieldValue({ key, value: '' })
            });
        }
    }, [useShippingAddress])

    useEffect(() => {
        if (previouslyPurchased === 'true') {
            setFieldValue({ key: 'useShippingAddress', value: 'false' })
        }
    }, [previouslyPurchased])

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.formGridItem}>
                <CreateAccountFormContext.Provider value={{ validators, countries }}>
                    <form id="createAccountForm" onSubmit={handleFormSubmit} noValidate>
                        <Typography variant="h2" as="h2">{translate("User Information")}</Typography>
                        <GridContainer>
                            <GridItem width={[12, 12, 6, 6, 6]}><Fields.UserEmail /></GridItem>
                            <GridItem width={[12, 12, 6, 6, 6]}><Fields.ConfirmUserEmail /></GridItem>
                            <GridItem width={[12, 12, 6, 6, 6]}><Fields.UserFirstName /></GridItem>
                            <GridItem width={[12, 12, 6, 6, 6]}><Fields.UserLastName /></GridItem>
                            <GridItem width={[12, 12, 6, 6, 6]}><Fields.UserJobTItle /></GridItem>
                            <GridItem width={[12, 12, 6, 6, 6]}><Fields.UserCompany /></GridItem>
                            <GridItem width={[12, 12, 6, 6, 6]}><Fields.WebsiteUrl /></GridItem>
                            <GridItem width={[12, 12, 6, 6, 6]}><Fields.Industry /></GridItem>
                            <GridItem width={[12, 12, 6, 6, 6]}><Fields.BusinessType /></GridItem>
                        </GridContainer>
                        {(!isPreviouslyPurchased) && <>
                            <GridContainer>
                                <GridItem width={12}>
                                    <Typography variant="h2" as="h2"><br />{translate("Shipping Address")}</Typography>
                                </GridItem>
                            </GridContainer>
                            <GridContainer>
                                <GridItem width={[12, 12, 6, 6, 6]}><Fields.ShippingCompany /></GridItem>
                                <GridItem width={[12, 12, 6, 6, 6]}><Fields.ShippingAddressLineOne /></GridItem>
                                <GridItem width={[12, 12, 6, 6, 6]}><Fields.ShippingAddressLineTwo /></GridItem>
                                <GridItem width={[12, 12, 6, 6, 6]}><Fields.ShippingCountry /></GridItem>
                                <GridItem width={[12, 12, 6, 6, 6]}><Fields.ShippingState /></GridItem>
                                <GridItem width={[12, 12, 6, 6, 6]}><Fields.ShippingCity /></GridItem>
                                <GridItem width={[12, 12, 6, 6, 6]}><Fields.ShippingZipCode /></GridItem>
                                <GridItem width={[12, 12, 6, 6, 6]}><Fields.ShippingPhone /></GridItem>
                            </GridContainer>
                        </>}
                        <GridContainer>
                            <GridItem width={12}>
                                <Typography variant="h2" as="h2"><br />{translate("Billing Address")}</Typography>
                            </GridItem>
                        </GridContainer>
                        {useShippingAddress === 'true' ? (
                            <GridContainer>
                                <GridItem width={12}><Fields.UseShippingAddress /></GridItem>
                            </GridContainer>
                        ) : (isPreviouslyPurchased ? (
                            <GridContainer>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingCountry /></GridItem>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingState /></GridItem>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingCity /></GridItem>
                             </GridContainer>
                         ) : (
                             <GridContainer>
                                 <GridItem width={12}><Fields.UseShippingAddress /></GridItem>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingCompany /></GridItem>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingAddressLineOne /></GridItem>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingAddressLineTwo /></GridItem>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingCountry /></GridItem>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingState /></GridItem>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingCity /></GridItem>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingZipCode /></GridItem>
                                 <GridItem width={[12, 12, 6, 6, 6]}><Fields.BillingPhone /></GridItem>
                             </GridContainer>
                         ))}

                        <TaxExemptionField
                            heading={widgetFields.taxExemptHeading}
                            checkboxLabel={widgetFields.taxExemptCheckboxLabel}
                            uploadTaxformContent={widgetFields.uploadTaxformContent}
                        />

                        <ReCaptcha recaptchaRef={recaptchaRef} location="ContactUs" />
                        <Button {...styles.submitButton} type="submit" disabled={isSubmitting}>
                            {submitButtonText}
                        </Button>
                    </form>
                </CreateAccountFormContext.Provider>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CreateAccountForm),
    definition: {
        group: "Create Account Form" as any,
        icon: "FormField",
        displayName: "Create Account Form",
        fieldDefinitions: [
            {
                name: fields.taxExemptHeading,
                displayName: "Tax Exempt Heading",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Tax Exemption",
            },
            {
                name: fields.taxExemptCheckboxLabel,
                displayName: "Tax Exempt Checkbox Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Does your company qualify for tax exempt status?",
            },
            {
                name: fields.uploadTaxformContent,
                displayName: "Upload Tax Form Content",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "",
            },
            {
                name: fields.submitButtonText,
                displayName: "Submit Button Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Submit Request",
            },
            {
                name: fields.successLink,
                displayName: "Redirect on success",
                editorTemplate: "LinkField",
                fieldType: "Translatable",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
